import { appendTestableComponentAttributes, Button, ButtonVariant } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { AcceptButton, RejectButton } from './AcceptRejectButtons';
import {
   StyledRedactionActions,
   StyledRedactionProposal,
   StyledRedactionProposalText,
   StyledRedactionProposalTitle,
} from './RedactionProposal.styled';

type RedactionProposalProps = {
   originalText: string;
   redactedText: string;
   onAccept: VoidFunction;
   onReject: VoidFunction;
   onRetry: VoidFunction;
};

export const RedactionProposal = (props: RedactionProposalProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledRedactionProposal
         {...appendTestableComponentAttributes('RedactionProposal', 'transcriptionRedactionProposal')}
         role='region'
         aria-live='polite'
         aria-atomic='true'
         aria-label={translate(translationKeys.panel.redactionProposalTitle)}
      >
         <StyledRedactionProposalTitle>
            {translate(translationKeys.panel.redactionOriginalTitle)}
         </StyledRedactionProposalTitle>
         <StyledRedactionProposalText>{props.originalText}</StyledRedactionProposalText>

         <StyledRedactionProposalTitle>
            {translate(translationKeys.panel.redactionProposalTitle)}
         </StyledRedactionProposalTitle>
         <StyledRedactionProposalText>{props.redactedText}</StyledRedactionProposalText>

         <StyledRedactionActions>
            <AcceptButton testId={'redactionAccept'} onClick={props.onAccept} />
            <RejectButton testId={'redactionReject'} onClick={props.onReject} />
            <Button
               testId={'redactionRetry'}
               label={translationKeys.panel.redactionRetry}
               onClick={props.onRetry}
               variant={ButtonVariant.PRIMARY}
            />
         </StyledRedactionActions>
      </StyledRedactionProposal>
   );
};
